import api from "./axios";
import { API_ENDPOINTS } from "../constants";
import { encryptJourneyQueryValue } from "../common/utils/journeyEncryption";
import { logError } from "../common/utils/logger";

export const uploadDocument = async (formData) => {
  try {
    if (typeof FormData !== "undefined" && formData instanceof FormData) {
      const app = formData.get("applicationNumber");
      if (app != null && String(app).trim() !== "") {
        formData.set("applicationNumber", encryptJourneyQueryValue(String(app)));
      }
      const dob = formData.get("dateOfBirth") || formData.get("dob") || formData.get("liDob");
      if (dob != null && String(dob).trim() !== "") {
        // Keep same key used by backend resolver (prefers dateOfBirth/dob/liDob).
        if (formData.get("dateOfBirth") != null) formData.set("dateOfBirth", encryptJourneyQueryValue(String(dob)));
        else if (formData.get("dob") != null) formData.set("dob", encryptJourneyQueryValue(String(dob)));
        else if (formData.get("liDob") != null) formData.set("liDob", encryptJourneyQueryValue(String(dob)));
      }
    }

    const response = await api.post(
      API_ENDPOINTS.DOCUMENT_UPLOAD,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response?.data ?? null;

  } catch (error) {
    logError("Document upload failed", error);
    throw error;
  }
};